import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ExpandIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M11.6667 8.33284L17.5 2.49951M17.5 2.49951L12.5 2.49951M17.5 2.49951V7.49951M8.33333 11.6662L2.5 17.4995M2.5 17.4995H7.5M2.5 17.4995L2.5 12.4995"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ExpandIcon;
